import { render, staticRenderFns } from "./website-news.vue?vue&type=template&id=084bf124&scoped=true"
import script from "./website-news.vue?vue&type=script&lang=js"
export * from "./website-news.vue?vue&type=script&lang=js"
import style0 from "./website-news.vue?vue&type=style&index=0&id=084bf124&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084bf124",
  null
  
)

export default component.exports